// components/RoleGuard.jsx
import { Navigate } from "react-router-dom";

const RoleGuard = ({ allowedRoles, children }) => {
  var userRole = sessionStorage.getItem("role");
  if (!allowedRoles.includes(userRole)) {
    console.log(allowedRoles[0] + " - - " + userRole);
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

const UserRoleGuard = ({ allowedRoles, children }) => {
  var userRole = sessionStorage.getItem("userrole").split(',');
  // Check if any role in userRole exists in allowedRoles
  if (!userRole.some(role => allowedRoles.includes(role))) {
    console.log(allowedRoles[0] + " - - " + userRole);
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export { RoleGuard, UserRoleGuard };
